import { type FhirLabValues } from 'flow-schema';

import { type Common } from '../../common.js';
import { type PatientDataStoreDocumentTranscriptionResponse } from '../../models/patient/document.js';
import {
  type PredictionSettings,
  type Question,
  type UpdateValues,
} from '../../models/patient/order/clinicalQuestion.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(args: {
    orderId: string;
    question: string;
    answerOptions?: string[];
    predictionOptions?: PredictionSettings;
    pageContents?: string | null;
    pageUrl?: string | null;
    existingDocuments?: PatientDataStoreDocumentTranscriptionResponse[] | null;
    existingLabValues?: FhirLabValues | null;
  }): Promise<Question> {
    const {
      orderId,
      question,
      answerOptions,
      predictionOptions,
      pageContents,
      pageUrl,
      existingDocuments,
      existingLabValues,
    } = args;
    const url = this.common.constructPath(`/patient-orders/clinicals/${orderId}/questions`);
    return await this.common.postJSON(url, {
      question,
      answerOptions,
      predictionOptions,
      pageContents,
      pageUrl,
      existingDocuments,
      existingLabValues,
    });
  }

  async update(args: { orderId: string; questionId: string; values: UpdateValues }) {
    const { orderId, questionId, values } = args;
    const url = this.common.constructPath(
      `/patient-orders/clinicals/${orderId}/questions/${questionId}`
    );
    return await this.common.patchJSON(url, values);
  }
}
